import React, { PropsWithChildren } from 'react';
import PlainButtonOrLink, {
  Props as PlainButtonOrLinkProps,
} from '../../../../Buttons/PlainButtonOrLink';
import FacetContent from '../../lego/FacetContent';
import { CommonFacetAPI, useFacet } from '../../common';

export interface Props extends CommonFacetAPI, Omit<PlainButtonOrLinkProps, 'children'> {
  buttonClassName?: string;
}

const FacetButton: React.FC<PropsWithChildren<Props>> = ({
  children,
  buttonClassName,
  ...props
}) => {
  const { rootComponentProps, contentComponentProps, implementationSpecificProps } =
    useFacet(props);

  return (
    <PlainButtonOrLink
      className={buttonClassName}
      {...rootComponentProps}
      {...implementationSpecificProps}
    >
      <FacetContent {...contentComponentProps}>{children}</FacetContent>
    </PlainButtonOrLink>
  );
};

FacetButton.displayName = 'FacetButton';

export default FacetButton;
